const falconDomain = 'falcon.birds.amazon.dev'
const egretDomain = 'egret.birds.amazon.dev'
const falconApiDomain = `api.${falconDomain}`

export const FALCON_CEDRIC_KEY = 'falcon_helper_bot_link'

export const BASE_URL = {
    ...Object.fromEntries(
        ['prod', 'gamma', 'beta'].map((env) => [env, `https://${env}.${falconApiDomain}`]),
    ),
    local: 'http://localhost:8080',
}

export const EGRET_URL = Object.fromEntries(
    ['prod', 'gamma', 'beta', 'local'].map((env) => [
        env,
        `https://${env !== 'local' ? env : 'beta'}.${egretDomain}`,
    ]),
)
interface RumConfigForStage {
    applicationId: string
    midwayRoleArn: string
    relyingParty: string
}
export const ACCOUNT_IDS = {
    local: '707848945221',
    beta: '707848945221',
    gamma: '110198564224',
    prod: '763259969412',
}
const getRumMidwayRoleName = (stage) =>
    `arn:aws:iam::${ACCOUNT_IDS[stage]}:role/FalconMidwayAuthenticatedRUMRole-${stage}`
const getRelyingParty = (stage) => `https://${stage}.${falconDomain}`
export const RUM_CONFIG: { [key: string]: RumConfigForStage } = {
    beta: {
        applicationId: '185081a3-61e9-44b3-9a9c-f3d9a11900bc',
        midwayRoleArn: getRumMidwayRoleName('beta'),
        relyingParty: getRelyingParty('beta'),
    },
    gamma: {
        applicationId: '87dd49b6-abf4-4b99-8b8c-d5f229717c1a',
        midwayRoleArn: getRumMidwayRoleName('gamma'),
        relyingParty: getRelyingParty('gamma'),
    },
    prod: {
        applicationId: '0c34a7de-ed26-4466-99a4-c7c3ebd9d0c7',
        midwayRoleArn: getRumMidwayRoleName('prod'),
        relyingParty: getRelyingParty('prod'),
    },
}
